import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftERPServer } from "namirasoft-erp";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { ErpLayout } from "./ErpLayout";
import { ErpRoutes } from "./ErpRoutes";
import { ErpScopeMode } from "./ErpScope";
import AccountEditPage from "./pages/AccountEditPage";
import AccountListPage from "./pages/AccountListPage";
import AccountViewPage from "./pages/AccountViewPage";
import BalanceSheetReportPage from "./pages/BalanceSheetReportPage";
import BranchEditPage from "./pages/BranchEditPage";
import BranchListPage from "./pages/BranchListPage";
import BranchViewPage from "./pages/BranchViewPage";
import CompanyEditPage from "./pages/CompanyEditPage";
import CompanyListPage from "./pages/CompanyListPage";
import CompanyViewPage from "./pages/CompanyViewPage";
import CurrencyEditPage from "./pages/CurrencyEditPage";
import CurrencyExchangeEditPage from "./pages/CurrencyExchangeEditPage";
import CurrencyExchangeListPage from "./pages/CurrencyExchangeListPage";
import CurrencyExchangeViewPage from "./pages/CurrencyExchangeViewPage";
import CurrencyListPage from "./pages/CurrencyListPage";
import CurrencyViewPage from "./pages/CurrencyViewPage";
import FiscalYearEditPage from "./pages/FiscalYearEditPage";
import FiscalYearListPage from "./pages/FiscalYearListPage";
import FiscalYearViewPage from "./pages/FiscalYearViewPage";
import FuelEditPage from "./pages/FuelEditPage";
import FuelListPage from "./pages/FuelListPage";
import FuelViewPage from "./pages/FuelViewPage";
import GeneralLedgerReportPage from "./pages/GeneralLedgerReportPage";
import GifiListPage from "./pages/GifiListPage";
import GifiViewPage from "./pages/GifiViewPage";
import GifiReportPage from "./pages/GifiReportPage";
import HomePage from "./pages/HomePage";
import JournalEntryEditPage from "./pages/JournalEntryEditPage";
import JournalEntryListPage from "./pages/JournalEntryListPage";
import JournalEntryViewPage from "./pages/JournalEntryViewPage";
import LockEditPage from "./pages/LockEditPage";
import LockListPage from "./pages/LockListPage";
import LockViewPage from "./pages/LockViewPage";
import LoginPage from "./pages/LoginPage";
import MaintenancePlanEditPage from "./pages/MaintenancePlanEditPage";
import MaintenancePlanListPage from "./pages/MaintenancePlanListPage";
import MaintenancePlanViewPage from "./pages/MaintenancePlanViewPage";
import OdometerEditPage from "./pages/OdometerEditPage";
import OdometerListPage from "./pages/OdometerListPage";
import OdometerViewPage from "./pages/OdometerViewPage";
import PartyEditPage from "./pages/PartyEditPage";
import PartyListPage from "./pages/PartyListPage";
import PartyTypeEditPage from "./pages/PartyTypeEditPage";
import PartyTypeListPage from "./pages/PartyTypeListPage";
import PartyTypeViewPage from "./pages/PartyTypeViewPage";
import PartyViewPage from "./pages/PartyViewPage";
import RefuelingEditPage from "./pages/RefuelingEditPage";
import RefuelingListPage from "./pages/RefuelingListPage";
import RefuelingViewPage from "./pages/RefuelingViewPage";
import ServiceEditPage from "./pages/ServiceEditPage";
import ServiceListPage from "./pages/ServiceListPage";
import ServiceTypeEditPage from "./pages/ServiceTypeEditPage";
import ServiceTypeListPage from "./pages/ServiceTypeListPage";
import ServiceTypeViewPage from "./pages/ServiceTypeViewPage";
import ServiceViewPage from "./pages/ServiceViewPage";
import TagEditPage from "./pages/TagEditPage";
import TagGroupEditPage from "./pages/TagGroupEditPage";
import TagGroupListPage from "./pages/TagGroupListPage";
import TagGroupViewPage from "./pages/TagGroupViewPage";
import TagListPage from "./pages/TagListPage";
import TagViewPage from "./pages/TagViewPage";
import VehicleEditPage from "./pages/VehicleEditPage";
import VehicleListPage from "./pages/VehicleListPage";
import VehicleViewPage from "./pages/VehicleViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_ERP}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_ERP = new EnvService("REACT_APP_BASE_URL_ERP", true).getString();

            let erp = new NamirasoftERPServer(REACT_APP_BASE_URL_ERP, result.account.token_manager, result.notifier.onError);

            let servers = { erp };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={ErpRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={ErpRoutes.CurrencyList} element={<CurrencyListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.CurrencyNew} element={<CurrencyEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.CurrencyView(":id")} element={<CurrencyViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.CurrencyEdit(":id")} element={<CurrencyEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.CurrencyCopy(":id")} element={<CurrencyEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.CurrencyExchangeList} element={<CurrencyExchangeListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.CurrencyExchangeNew} element={<CurrencyExchangeEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.CurrencyExchangeView(":id")} element={<CurrencyExchangeViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.CurrencyExchangeEdit(":id")} element={<CurrencyExchangeEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.CurrencyExchangeCopy(":id")} element={<CurrencyExchangeEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.CompanyList} element={<CompanyListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.CompanyNew} element={<CompanyEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.CompanyView(":id")} element={<CompanyViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.CompanyEdit(":id")} element={<CompanyEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.CompanyCopy(":id")} element={<CompanyEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.BranchList} element={<BranchListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.BranchNew} element={<BranchEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.BranchView(":id")} element={<BranchViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.BranchEdit(":id")} element={<BranchEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.BranchCopy(":id")} element={<BranchEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.FiscalYearList} element={<FiscalYearListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.FiscalYearNew} element={<FiscalYearEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.FiscalYearView(":id")} element={<FiscalYearViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.FiscalYearEdit(":id")} element={<FiscalYearEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.FiscalYearCopy(":id")} element={<FiscalYearEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.AccountList} element={<AccountListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.AccountNew} element={<AccountEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.AccountView(":id")} element={<AccountViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.AccountEdit(":id")} element={<AccountEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.AccountCopy(":id")} element={<AccountEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.PartyTypeList} element={<PartyTypeListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.PartyTypeNew} element={<PartyTypeEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.PartyTypeView(":id")} element={<PartyTypeViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.PartyTypeEdit(":id")} element={<PartyTypeEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.PartyTypeCopy(":id")} element={<PartyTypeEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.PartyList} element={<PartyListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.PartyNew} element={<PartyEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.PartyView(":id")} element={<PartyViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.PartyEdit(":id")} element={<PartyEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.PartyCopy(":id")} element={<PartyEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.TagGroupList} element={<TagGroupListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.TagGroupNew} element={<TagGroupEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.TagGroupView(":id")} element={<TagGroupViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.TagGroupEdit(":id")} element={<TagGroupEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.TagGroupCopy(":id")} element={<TagGroupEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.TagList} element={<TagListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.TagNew} element={<TagEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.TagView(":id")} element={<TagViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.TagEdit(":id")} element={<TagEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.TagCopy(":id")} element={<TagEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.LockList} element={<LockListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.LockNew} element={<LockEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.LockView(":id")} element={<LockViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.LockEdit(":id")} element={<LockEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.LockCopy(":id")} element={<LockEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.JournalEntryList} element={<JournalEntryListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.JournalEntryNew} element={<JournalEntryEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.JournalEntryView(":id")} element={<JournalEntryViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.JournalEntryEdit(":id")} element={<JournalEntryEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.JournalEntryCopy(":id")} element={<JournalEntryEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.VehicleList} element={<VehicleListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.VehicleNew} element={<VehicleEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.VehicleView(":id")} element={<VehicleViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.VehicleEdit(":id")} element={<VehicleEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.VehicleCopy(":id")} element={<VehicleEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.ServiceTypeList} element={<ServiceTypeListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.ServiceTypeNew} element={<ServiceTypeEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.ServiceTypeView(":id")} element={<ServiceTypeViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.ServiceTypeEdit(":id")} element={<ServiceTypeEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.ServiceTypeCopy(":id")} element={<ServiceTypeEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.MaintenancePlanList} element={<MaintenancePlanListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.MaintenancePlanNew} element={<MaintenancePlanEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.MaintenancePlanView(":id")} element={<MaintenancePlanViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.MaintenancePlanEdit(":id")} element={<MaintenancePlanEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.MaintenancePlanCopy(":id")} element={<MaintenancePlanEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.ServiceList} element={<ServiceListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.ServiceNew} element={<ServiceEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.ServiceView(":id")} element={<ServiceViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.ServiceEdit(":id")} element={<ServiceEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.ServiceCopy(":id")} element={<ServiceEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.OdometerList} element={<OdometerListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.OdometerNew} element={<OdometerEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.OdometerView(":id")} element={<OdometerViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.OdometerEdit(":id")} element={<OdometerEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.OdometerCopy(":id")} element={<OdometerEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.FuelList} element={<FuelListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.FuelNew} element={<FuelEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.FuelView(":id")} element={<FuelViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.FuelEdit(":id")} element={<FuelEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.FuelCopy(":id")} element={<FuelEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.RefuelingList} element={<RefuelingListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.RefuelingNew} element={<RefuelingEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ErpRoutes.RefuelingView(":id")} element={<RefuelingViewPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.RefuelingEdit(":id")} element={<RefuelingEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ErpRoutes.RefuelingCopy(":id")} element={<RefuelingEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ErpRoutes.ReportGeneralLedger} element={<GeneralLedgerReportPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.ReportBalanceSheet} element={<BalanceSheetReportPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.ReportGifi} element={<GifiReportPage {...result} servers={servers} />} />

                            <Route path={ErpRoutes.GifiList} element={<GifiListPage {...result} servers={servers} />} />
                            <Route path={ErpRoutes.GifiView(":code")} element={<GifiViewPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={ErpRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <ErpLayout {...props} mode={ErpScopeMode.None}>
                {props.children}
            </ErpLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;